"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Placeholder = exports.ContentPlaceholderBox = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const slide = (0, _styledComponents.keyframes)(["0%{background-position:-200px 0;}100%{background-position:calc(200px + 100%) 0;}"]);
const ContentPlaceholderBox = exports.ContentPlaceholderBox = _styledComponents.default.span.withConfig({
  displayName: "styles__ContentPlaceholderBox",
  componentId: "sc-kllh5h-0"
})([""]);
const Placeholder = exports.Placeholder = _styledComponents.default.span.withConfig({
  displayName: "styles__Placeholder",
  componentId: "sc-kllh5h-1"
})(["background-color:", ";background-image:linear-gradient( 90deg,", ",", ",", " );background-size:200px 100%;background-repeat:no-repeat;display:inline-block;line-height:1;width:100%;animation:", " 1.2s ease-in-out infinite;"], ({
  theme
}) => theme.colors.contentPlaceholder.bgColor, ({
  theme
}) => theme.colors.contentPlaceholder.bgColor, ({
  theme
}) => theme.colors.contentPlaceholder.gradientTint, ({
  theme
}) => theme.colors.contentPlaceholder.bgColor, slide);